import { useCallback } from 'react';
import { useGetOne, } from 'react-admin';
import { useSubscribeToRecord } from './useSubscribeToRecord';
/**
 * Alternative to useGetOne() that subscribes to live updates on the record
 *
 * @example
 *
 * import { useRecordContext } from 'react-admin';
 * import { useGetOneLive } from '@react-admin/ra-realtime';
 *
 * const UserProfile = () => {
 *     const record = useRecordContext();
 *     const { data, isLoading, error } = useGetOneLive('users', { id: record.id });
 *     if (isLoading) { return <Loading />; }
 *     if (error) { return <p>ERROR</p>; }
 *     return <div>User {data.username}</div>;
 * };
 */
export var useGetOneLive = function (resource, _a, options) {
    var id = _a.id, meta = _a.meta;
    var res = useGetOne(resource, { id: id, meta: meta }, options);
    var refetch = res.refetch;
    var callback = useCallback(function () {
        refetch({ cancelRefetch: true });
    }, [refetch]);
    useSubscribeToRecord(callback, resource, id);
    return res;
};
